import {FC} from 'react';
import {useField} from 'formik';
import {useTranslation} from 'react-i18next';
import {useSelector} from 'react-redux';
import useShow, {TShow} from '../../../../../hooks/useShow';
import {RootState} from '../../../../../redux/store.type';
import {THall} from '../../../../../redux/timetable/timetable.type';
import {hallOutline} from '../../../../../assets/symbols/symbols/Symbols.css';
import SelectPopup from '../../../../../component/selectPopup/SelectPopup';
import AddHallPopup from './AddHallPopup';

interface HallSelectPopupProps {
    show: TShow;
}

const HallSelectPopup: FC<HallSelectPopupProps> = ({show}) => {
    const {t} = useTranslation('timetable');
    const [field, , helpers] = useField<number | null>('thid');
    const halls = useSelector((state: RootState) => state.timetable.halls);
    const addShow = useShow();

    const items = halls.map((h: THall) => ({id: h.thid, text: h.title}));
    const handleAdd = (thid: number) => { helpers.setValue(thid); };

    return (
        <>
            {!addShow.isOpen && (
                <SelectPopup
                    show={show}
                    title={t('selectHallTitle')}
                    items={items}
                    selectedIds={field.value !== null ? [field.value] : []}
                    onConfirm={ids => helpers.setValue(ids[0] ?? null)}
                    allowDeselect
                    addAction={{text: t('addHall'), emptyText: t('addNewHall'), onClick: addShow.open}}
                    empty={{
                        icon: hallOutline,
                        text: t('noHallsYet'),
                        noResultsText: term => (
                            <>{t('noResultsFor', {term})}<br />{t('tryAnotherName')}</>
                        ),
                    }}
                />
            )}
            <AddHallPopup show={addShow} onAdd={handleAdd} />
        </>
    );
};

export default HallSelectPopup;
